import React from 'react';
import cn from 'classnames';
import styles from './SubjectCard.module.scss';
import { useLocalStorage } from '../../hooks';

type Props = {
  id: number;
  title: string;
  date: string;
  list: string[];
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  bgColor: string;
  onValidationOpen(): void;
  onSendEvent(): void;
};

export function SubjectCard({
  title,
  date,
  list,
  icon,
  bgColor,
  onValidationOpen,
  onSendEvent,
}: Props) {
  const Icon = icon;
  const [seenSorry] = useLocalStorage('seenSorry', false);

  return (
    <div className={styles.root}>
      <div className={styles.upperWrapper} style={{ backgroundColor: bgColor }}>
        <div className={styles.cardBg} />
        <Icon className={styles.icon} />
        <div className={styles.date} dangerouslySetInnerHTML={{ __html: date }} />
        <p className={cn(styles.cardTitle)} dangerouslySetInnerHTML={{ __html: title }} />
      </div>
      <div className={styles.content}>
        <ul className={styles.list}>
          {list.map((item) => (
            <li key={item} dangerouslySetInnerHTML={{ __html: item }} />
          ))}
        </ul>
      </div>
      {!seenSorry && (
        <button
          type="button"
          className={styles.button}
          onClick={() => {
            onSendEvent();
            onValidationOpen();
          }}
        >
          <div className={styles.border} />
          Оформить доступ
        </button>
      )}
    </div>
  );
}
